export function buildUserTraits(user) {
  const roleInterests = user.role_interests;

  const toTraits = (emailSha256) => ({
    emailSha256,
    icpType: user.icp_type != null ? user.icp_type : null,
    icpTypeSource: user.icp_type_source != null ? user.icp_type_source : null,
    icpConfidence: user.icp_confidence != null ? user.icp_confidence : null,
    companySize: user.company_size != null ? user.company_size : null,
    companyDomain: user.company_domain != null ? user.company_domain : null,
    companyIndustry: user.company_industry != null ? user.company_industry : null,
    companyFundingStage:
      user.company_funding_stage != null ? user.company_funding_stage : null,
    companyFundingLastRaisedAt:
      user.company_funding_last_raised_at != null
        ? user.company_funding_last_raised_at
        : null,
    firstTouchSource:
      user.first_touch_source != null ? user.first_touch_source : null,
    firstTouchMedium:
      user.first_touch_medium != null ? user.first_touch_medium : null,
    firstTouchCampaign:
      user.first_touch_campaign != null ? user.first_touch_campaign : null,
    firstTouchContent:
      user.first_touch_content != null ? user.first_touch_content : null,
    firstTouchTerm:
      user.first_touch_term != null ? user.first_touch_term : null,
    firstTouchAt: user.first_touch_at != null ? user.first_touch_at : null,
    lastTouchSource:
      user.last_touch_source != null ? user.last_touch_source : null,
    lastTouchMedium:
      user.last_touch_medium != null ? user.last_touch_medium : null,
    lastTouchCampaign:
      user.last_touch_campaign != null ? user.last_touch_campaign : null,
    lastTouchContent:
      user.last_touch_content != null ? user.last_touch_content : null,
    lastTouchTerm:
      user.last_touch_term != null ? user.last_touch_term : null,
    lastTouchAt: user.last_touch_at != null ? user.last_touch_at : null,
    intentAtSignup:
      user.intent_at_signup != null ? user.intent_at_signup : null,
    priority: user.priority != null ? user.priority : null,
    jobsPostedCount:
      user.jobs_posted_count != null ? user.jobs_posted_count : null,
    hiresMadeCount:
      user.hires_made_count != null ? user.hires_made_count : null,
    roleInterests: Array.isArray(roleInterests) ? roleInterests.slice() : [],
  });

  return hashEmailSha256(user.email)
    .then(toTraits)
    .catch((error) => {
      console.error('Failed to hash email for tracking:', error);
      return toTraits(null);
    });
}

function digestToHex(digest) {
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

/**
 * SHA-256 of normalized email (lowercase, trimmed). Never returns raw email.
 */
async function hashEmailSha256(email) {
  const normalized = (email || '').trim().toLowerCase();
  if (!normalized) {
    return null;
  }

  try {
    if (typeof crypto !== 'undefined' && crypto.subtle) {
      const data = new TextEncoder().encode(normalized);
      const digest = await crypto.subtle.digest('SHA-256', data);
      return digestToHex(digest);
    }

    if (typeof process !== 'undefined' && process.versions && process.versions.node) {
      // eslint-disable-next-line global-require
      const nodeCrypto = require('crypto');
      return nodeCrypto.createHash('sha256').update(normalized, 'utf8').digest('hex');
    }
  } catch (error) {
    console.error('Failed to hash email for tracking:', error);
    return null;
  }

  return null;
}
